import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZdfComponent } from './simple-icons-zdf.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZdfComponent ],
    exports:      [ SimpleIconsZdfComponent ],
    bootstrap:    []
})
export class SimpleIconsZdfModule {}
